// First, update your CameraViewCard to remove the custom selection logic
import { GalleryItem, GalleryCard } from "../../component/CardGallery";
import React, { useState } from 'react';
import { Card, CardMedia, CardActionArea, CardContent, Typography } from '@mui/material';
import { PictureOutlined } from '@ant-design/icons';

export interface CameraViewItem extends GalleryItem {
  camera: string;
  trigger: string;
  path: string;
  label: string;
}

// Remove the isSelected prop since CardGallery will handle selection styling
export const CameraViewCard: React.FC<GalleryCard<CameraViewItem>> = ({ 
  item, 
  onNavigate 
}) => {
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    onNavigate(item.id);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Card
      sx={{
        maxWidth: 500,
        margin: 1,
        border: '1px solid #f0f0f0',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
        borderRadius: '2px',
        transition: 'all 0.3s',
      }}
      className="image-preview"
    >
      <CardActionArea onClick={handleClick}>
        {imageError || !item.path ? (
          <div
            style={{
              height: '240px',
              backgroundColor: '#f5f5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              padding: '16px',
              boxSizing: 'border-box',
            }}
          >
            <PictureOutlined style={{ fontSize: 32, color: '#bfbfbf'}}/>
            <Typography 
              variant="caption" 
              sx={{ 
                marginTop: 1, 
                color: '#8c8c8c',
                fontSize: '12px'
              }}
            >
              Camera View Not Available
            </Typography>
          </div>
        ) : (
          <CardMedia
            component="img"
            src={item.path}
            alt={`Camera ${item.camera} / Trigger ${item.trigger}`}
            onError={handleImageError}
            sx={{ objectFit: 'cover' }}
          />
        )}
        <CardContent sx={{ padding: '12px 16px' }}>
          <Typography variant="subtitle1" sx={{ fontSize: '14px', fontWeight: 500 }}>
            Camera View
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '12px' }}>
            Camera: {item.camera}, Trigger: {item.trigger}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};